import { ADRESSVORSCHLAG_FAILED_REASON } from '@ps20-frontend/frontend-models';

export enum CALLER_ID {
  SICHERUNGSLAEUBIGER = 'SICHERUNGSLAEUBIGER',
  VERMIETETE_WOHNUNG = 'VERMIETETE_WOHNUNG',
  VWG_BASISDATEN = 'VWG_BASISDATEN',
  VHV_BASISDATEN = 'VHV_BASISDATEN',
  PH_BASISDATEN = 'PH_BASISDATEN',
  RS_BASISDATEN = 'RS_BASISDATEN',
  RS_VERMIETUNG_BASISDATEN = 'RS_VERMIETUNG_BASISDATEN',
  THH_HUND_BASISDATEN = 'THH_HUND_BASISDATEN',
  THH_HUND_MELDEBEHOERDE = 'THH_HUND_MELDEBEHOERDE',
  JHP_JAGDBEHOERDE = 'JHP_JAGDBEHOERDE',
  THH_PFERD_BASISDATEN = 'THH_PFERD_BASISDATEN',
  TKV_BASISDATEN = 'TKV_BASISDATEN',
  RS_VERMIETETE_OBJEKTE = 'RS_VERMIETETE_OBJEKTE',
  RS_VERMIETUNG_VERMIETETE_OBJEKTE = 'RS_VERMIETUNG_VERMIETETE_OBJEKTE',
  CHECKOUT_PERSONEN_SUCHE = 'CHECKOUT_PERSONEN_SUCHE',
  CHECKOUT_AZAM_ABWEICHENDER_KONTOINHABER = 'CHECKOUT_AZAM_ABWEICHENDER_KONTOINHABER',
  CHECKOUT_AZAM_BEZUGSBERECHTIGTER = 'CHECKOUT_AZAM_BEZUGSBERECHTIGTER',
}

interface CallerData {
  index: number;
  nurOrte: boolean;
}

export interface AddressvorschlagAction {
  callerId: CALLER_ID | string;
  callerData?: CallerData;
  plz: string;
  angebotsId?: string;
}

export interface AdressvorschlagFailedPayload {
  callerId: CALLER_ID | string;
  callerData?: CallerData;
  reason: ADRESSVORSCHLAG_FAILED_REASON;
}

export interface AdressvorschlagPayload {
  strassen: Array<string>;
  orte: Array<string>;
  callerId: CALLER_ID | string;
  callerData?: CallerData;
}
